import { Accordion, AccordionDetails, AccordionSummary, FormControl, IconButton, InputBase, InputLabel, MenuItem, OutlinedInput, Paper, Select, Skeleton } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import { ComplexityDescription } from "./ComplexityDescription";
import classes from "./ComplexityAccordion.module.scss";
import { useEffect, useState, useContext } from "react";
import { Row, Col, Container } from "react-bootstrap";
import JSONPretty from "../../jsonPrettyOverride/JSONPretty";
import { OrgIdContext } from "../../../store/orgId_context";
import { tx } from "../../../lib/ddd/ddd";
import PolylineIcon from '@mui/icons-material/Polyline';
import DataObjectIcon from '@mui/icons-material/DataObject';

export const ComplexityAccordion = ({expended="Normal", connectionKey, initialInvoiceObj}) => {
    const [expendedComplexity, setExpendedComplexity] = useState(expended);
    const [objectResponse, setObjectResponse] = useState(initialInvoiceObj);
    const [fieldKeys, setFieldKeys] = useState(null);
    const [minimalObj, setMinimalObj] = useState();
    const [normalObj, setNormalObj] = useState();
    const [normalUniqueKey, setNormalUniqueKeys] = useState();
    const [maximalObj, setMaximalObj] = useState();
    const [maximalUniqueKey, setMaximalUniqueKeys] = useState();
    const [search, setSearch] = useState();
    const { integrationDevice} = useContext(OrgIdContext);

    const reqParam = {Complexity: expendedComplexity};

    const onChangeExpendedComplexity = (complexity) => {
        setExpendedComplexity(complexity);

        if(complexity === "Minimal" && minimalObj){
            setObjectResponse(minimalObj.DDDI_GetNew)
            setFieldKeys([]);
        }
        if(complexity === "Normal" && normalObj){
            setObjectResponse(normalObj.DDDI_GetNew)
            setFieldKeys(normalUniqueKey);
        }
        if(complexity === "Maximal" && maximalObj){
            setObjectResponse(maximalObj.DDDI_GetNew)
            setFieldKeys(maximalUniqueKey);
        }
    }

    useEffect(()=>{
        if(expendedComplexity === "Minimal" && minimalObj){
            setObjectResponse(minimalObj.DDDI_GetNew)
            setFieldKeys([]);
        }
        if(expendedComplexity === "Normal" && normalObj){
            setObjectResponse(normalObj.DDDI_GetNew)
            setFieldKeys(normalUniqueKey);
        }
        if(expendedComplexity === "Maximal" && maximalObj){
            setObjectResponse(maximalObj.DDDI_GetNew)
            setFieldKeys(maximalUniqueKey);
        }
    }, [expendedComplexity])

    const onTableArrayBuilt = (complexity, tableArray, detailsArray, serverResponse) => {
        if(complexity === "Minimal"){
            if(!minimalObj)
                setMinimalObj(serverResponse);
            if(complexity===expendedComplexity){
                setObjectResponse(serverResponse.DDDI_GetNew)
                setFieldKeys([]);
            }
        }

        if(complexity === "Normal"){
            if(!normalObj){
                setNormalObj(serverResponse);
                console.log(tableArray);
                console.log(detailsArray);
                let keys = getNotInMinimalFieldKeys(tableArray, detailsArray);
                console.log(keys);
                setNormalUniqueKeys(keys);
                if(complexity===expendedComplexity){
                    setObjectResponse(serverResponse.DDDI_GetNew)
                    setFieldKeys(keys);
                }
            }
        }

        if(complexity === "Maximal"){
            if(!maximalObj){
                setMaximalObj(serverResponse);
                let keys = getNotInMinimalFieldKeys(tableArray, detailsArray);
                console.log(keys);
                setMaximalUniqueKeys(keys);
                if(complexity===expendedComplexity){
                    setObjectResponse(serverResponse.DDDI_GetNew)
                    setFieldKeys(keys);
                }
            }
        }
    }

    const getNotInMinimalFieldKeys = (tableArr, detailsArray) => {
        let ret = [];
        tableArr.forEach(field => {
            if(field.ui?.notInMinimal)
                ret.push(field.fieldName);
        })

        detailsArray.forEach(detail => {
            if(detail.notInMinimal)
                ret.push(detail.detail);

            detail.fields.forEach(field => {
                if(field.ui?.notInMinimal)
                    ret.push(field.fieldName);
            });
        })

        return ret;
    }
    const onComplexityChange = (e) => {
        setExpendedComplexity(e.target.value)
    }
    return (
        <div className="w-100" style={{padding:"0rem 3rem"}}>
            <Row className = "g-5">
                <div className={`${classes["complexityTitle"]}`}><PolylineIcon/>What is Complexity?</div>
                <div className={`${classes["complexityText"]} ${classes["container"]}`} style={{background:"white"}}>
                    <p>
                        Complexity is a parameter which you will have to send with most of your post requests. Its purpose is to ease your work with the invoice
                        object depending on your needs. It does that, by limiting the amount of infomation you must sent with your invoices
                        depending on which Complexity you are using. The options for Complexity are the following: 
                    </p>
                    <p>
                        <ul style={{listStyleType:"none", padding:"0px", margin:"0px"}}>
                            <li style={{fontWeight:"600"}}><i className="ti-file"/> Minimal</li>
                                <span style={{marginLeft:"1rem"}}>Suitable for light clients that can only generate classic invoices.</span>
                            <li style={{fontWeight:"600"}}><i className="ti-layers"/> Normal</li>
                                <span style={{marginLeft:"1rem"}}>This is the default option and is suitable for all invoice types, including advances, credit notes, and others. Properties that are additional (not included in Minimal) are marked.</span>
                            <li style={{fontWeight:"600"}}><i className="ti-layers-alt"/> Maximal</li>
                                <span style={{marginLeft:"1rem"}}>Supports the same invoice types as Normal, but includes all (rarely used) invoice data defined by the Peppol and UBL formats.</span>
                        </ul>
                    </p>
                    <p>
                        The table of parameters accompanied by an the invoice object depending on which complexity you select is below.
                    </p>
                    {/* <p>To get a new blank object, you simply send a request to <span className={classes["complexityApiText"]}>EUeInvoices.DDDI_GetNew</span> and you will get an already initialized blank Invoice object.
                    The Invoice object will already have some information filled, which will depend on your country and company default settings. Because these values are subject
                    to change (country's laws, company setting) it is best to request this object everytime and not store it locally for longer periods of time.</p>
                    <p>Complexity parameter 
                    (<span className="__json-pretty__"><span className="__json-key__">Complexity</span><span>:</span><span className="__json-string__">"Normal"</span></span>) 
                    is there for you, to ease your work depending on the information your Invoices you require. There are three options available for you: "Minimal", "Normal", "Maximal".
                    If you require only basic Invoices, then Minimal...</p> */}
                </div>
                <div className={`${classes["complexityTitle"]}`}><DataObjectIcon/>How to get initialized blank invoice</div>
                <div className={`${classes["complexityText"]} ${classes["container"]}`} style={{background:"white"}}>
                    <Row>
                        <Col>
                        
                    <p>
                        To get a new blank invoice object, you simply send a request to <span className={classes["complexityApiText"]}>{tx("EUeInvoices.DDDI_GetNew")}</span> and you will get an already initialized blank Invoice object.
                        The Invoice object will already have some information filled, which will depend on your country and company default settings. Because these values are subject
                        to change (country's laws, company setting) it is best to request this object everytime and not store it locally for longer periods of time.
                    </p>
                    <div className={classes["code-snippet"]}>
                    curl -X POST https://{window.location.hostname}/api/service/<span className={classes.green}>{tx("EUeInvoices.DDDI_GetNew")}</span> -H "Authorization: IoT <span className={classes.green}>{integrationDevice}</span>:EUeInvoices" -H "Content-Type: application/json" -d "<span className={classes.green}>{JSON.stringify(JSON.stringify(reqParam))}</span>"
                    </div>
                    {/* <p>
                        Below, in the object preview display, there is an example of such an initialized invoice.
                    </p> */}
                    </Col>
                    <Col>
                        Example response:
                        {!objectResponse && <Skeleton style={{WebkitTransform:"none"}} width="100%" height="30vh"/>}
                        {objectResponse && <div className={classes["json-wrapper"]} style={{textAlign : "left", maxHeight:"30vh", height:"100%"}}>
                            <JSONPretty data={objectResponse}></JSONPretty>
                        </div>}
                    </Col>
                    </Row>
                </div>
                <div className={`${classes["complexityTitle"]}`}><DataObjectIcon/>How to get enums/options</div>
                <div className={`${classes["complexityText"]} ${classes["container"]}`} style={{background:"white"}}>
                    <Row>
                        <Col className="col-6">
                            <p>
                                Some invoice properties accept only certain values as valid (enum). Below in the table, you can see these properies and their accepted values.
                                If you don't wish to copy those values, you can dynamically include them in your solutions by using one of our following APIs: <span className={classes["complexityApiText"]}></span>
                            </p>
                            <div className={classes["code-snippet"]}>
                            curl -X POST https://{window.location.hostname}/api/service/<span className={classes.green}>EUeInvoices.UI_GetNew</span> -H "Authorization: IoT <span className={classes.green}>{integrationDevice}</span>:EUeInvoices" -H "Content-Type: application/json" -d "<span className={classes.green}>{JSON.stringify(JSON.stringify(reqParam))}</span>"
                            </div>
                            <p>
                                If you scroll through the response of this request, you will see that it includes a lot of useful information required to construct an invoice (initial value, valid values, required)
                            </p>
                        </Col>
                        <Col className="col-6">
                            Example response:
                            {!normalObj && <Skeleton style={{WebkitTransform:"none"}} width="100%" height="40vh"/>}
                            {normalObj && <div className={classes["json-wrapper-small"]}>
                                <JSONPretty data={normalObj?.UI_GetNew}></JSONPretty>
                            </div>}
                        </Col>
                    </Row>
                </div>
            </Row>
            <Row>
            <div className="m-3"></div>
            <Col className="col-md-8">
                <div className="d-flex align-items-center" style={{marginBottom:"1rem", borderBottom:"1px solid grey"}}>
                    <FormControl>
                        <InputLabel id="complexity-label" sx={{color:"#005683", "&.Mui-focused": {color:"#005683"}}}>Complexity</InputLabel>
                    <Select
                        labelId="complexity-label"
                        id="complexity-select"
                        value={expendedComplexity}
                        onChange={onComplexityChange}
                        sx={{
                            width:"300px", 
                            background:"white", 
                            height:"3rem",
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline':{
                                borderColor:'inherit'
                            },
                        }}
                        input={<OutlinedInput notched label={"Complexity"} />}
                    >
                        <MenuItem value={"Minimal"}><i className={`${classes["accordionIcon"]} ti-file`}></i>Minimal</MenuItem>
                        <MenuItem value={"Normal"}><i className={`${classes["accordionIcon"]} ti-layers`}></i>Normal</MenuItem>
                        <MenuItem value={"Maximal"}><i className={`${classes["accordionIcon"]} ti-layers-alt`}></i>Maximal</MenuItem>
                    </Select>
                    </FormControl>
                    <div class="ms-auto">
                        <Paper component="form" onSubmit={(e) => {e.preventDefault();}}>
                            <InputBase sx={{ ml: 1, flex: 1 }}
                                placeholder="Search for field"
                                inputProps={{ 'aria-label': 'search fieldname' }}
                                value={search}
                                onChange={(e) => {setSearch(e.target.value)}}
                            />
                            <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
                                <SearchIcon />
                            </IconButton>
                        </Paper>
                    </div>
                </div>
                </Col>
                <Col className="col-md-4"></Col>
            </Row>
            <Row>
                <Col className="col-md-8">
                    <div  className={classes["accordion-wrapper"]} style={{maxHeight:"80vh", overflow:"auto"}}>
                        {expendedComplexity==="Minimal" && <ComplexityDescription complexity="Minimal" search={search} connectionKey={integrationDevice} markComplexityDifferences={true} onTableArrayCreated={onTableArrayBuilt}/>}
                        {expendedComplexity==="Normal" && <ComplexityDescription complexity="Normal" search={search} connectionKey={integrationDevice} markComplexityDifferences={true} onTableArrayCreated={onTableArrayBuilt}/>}
                        {expendedComplexity==="Maximal" && <ComplexityDescription complexity="Maximal" search={search} connectionKey={integrationDevice} markComplexityDifferences={true} onTableArrayCreated={onTableArrayBuilt}/>}
                    </div>
                    {/* <Accordion className={classes["accordion"]} expanded={expendedComplexity === 'Minimal'} onChange={() => onChangeExpendedComplexity('Minimal')}>
                        <AccordionSummary className={classes["accordionSummary"]} expandIcon={<i className="ti-angle-up"></i>}>
                        <i className={`${classes["accordionIcon"]} ti-file`}></i>Minimal
                        </AccordionSummary>
                        <AccordionDetails>
                        <div className={classes["accordion-wrapper"]}>
                            <ComplexityDescription complexity="Minimal" connectionKey={connectionKey} markComplexityDifferences={true} onTableArrayCreated={onTableArrayBuilt}></ComplexityDescription>
                        </div>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className={classes["accordion"]} expanded={expendedComplexity === 'Normal'} onChange={() => onChangeExpendedComplexity('Normal')}>
                        <AccordionSummary className={classes["accordionSummary"]}  expandIcon={<i className="ti-angle-up"></i>}>
                        <i className={`${classes["accordionIcon"]} ti-layers`}></i>Normal
                        </AccordionSummary>
                        <AccordionDetails>
                        <div className={classes["accordion-wrapper"]} >
                            <ComplexityDescription complexity="Normal" connectionKey={connectionKey} markComplexityDifferences={true} onTableArrayCreated={onTableArrayBuilt}></ComplexityDescription>
                        </div>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className={classes["accordion"]} expanded={expendedComplexity === 'Maximal'} onChange={() => onChangeExpendedComplexity('Maximal')}>
                        <AccordionSummary className={classes["accordionSummary"]}  expandIcon={<i className="ti-angle-up"></i>}>
                        <i className={`${classes["accordionIcon"]} ti-layers-alt`}></i>Maximal
                        </AccordionSummary>
                        <AccordionDetails>
                        <div className={classes["accordion-wrapper"]}>
                            <ComplexityDescription complexity="Maximal" connectionKey={connectionKey} markComplexityDifferences={true} onTableArrayCreated={onTableArrayBuilt}></ComplexityDescription>
                        </div>
                        </AccordionDetails>
                    </Accordion> */}
                </Col>
                <Col className="col-md-4">
                <div className={classes["json-wrapper-main"]} style={{textAlign : "left"}}>
                    <JSONPretty data={objectResponse} fieldKeys={fieldKeys}></JSONPretty>
                </div>
                </Col>
            </Row>
            <Row>
                
            </Row>
        </div>
    )
}